export function parseCuitToNumber(cuit: string | number | null | undefined): number {
  if (cuit === null || cuit === undefined) {
    throw new Error('CUIT is required');
  }

  const cuitStr = cuit.toString().replace(/[^0-9]/g, '');

  if (cuitStr.length === 0) {
    throw new Error('CUIT cannot be empty');
  }

  const cuitNumber = parseInt(cuitStr, 10);

  if (isNaN(cuitNumber)) {
    throw new Error('Invalid CUIT format');
  }

  return cuitNumber;
}

export const cuitValidator = (cuit: string) => {
  if (cuit.length !== 11) {
    return { invalidCuit: true };
  }

  let acumulado = 0;
  let digitos = cuit.split('');
  let digito = parseInt(digitos.pop());

  for (let i = 0; i < digitos.length; i++) {
    acumulado += parseInt(digitos[i]) * (2 + ((digitos.length - i - 1) % 6));
  }

  let verif = 11 - (acumulado % 11);
  if (verif === 11) {
    verif = 0;
  } else if (verif === 10) {
    verif = 9;
  }

  return digito === verif ? null : { invalidCuit: true };
};
